module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<a id="cta_holder" class="cta_item_container" href="' +
((__t = ( decode_utf8_link(link) )) == null ? '' : __t) +
'"  target="' +
((__t = ( gon.display_options.ctaCurrentTab || gon.current_account.extra_fields.ctaCurrentTab ? '_top' : '_blank')) == null ? '' : __t) +
'">\n	';
if (gon.display_options.reviewOptions && gon.display_options.reviewOptions.lightboxReviews && review.active){ ;
__p += '\n   <div class="review_holder">\n   		<div class="review_center">\n			<div class="star_holder star_' +
((__t = ( review.score )) == null ? '' : __t) +
'"></div>\n			<div class="reviewer_title">' +
((__t = ( review.title )) == null ? '' : __t) +
'</div>\n			';
 if (review.incentivized) { ;
__p += '\n			<p class="review_incentivized">' +
((__t = ( incentivizedText )) == null ? '' : __t) +
'</p>\n			';
 } ;
__p += '\n			<div class="review_text"><p>' +
((__t = ( review.content )) == null ? '' : __t) +
'</p></div>\n			<div class="reviewer_name">' +
((__t = ( review.user_name )) == null ? '' : __t) +
'</div>\n   		</div>\n   </div>\n	';
 } ;
__p += '\n\n	<div id="cta_content">\n		';
 if(!isFalsy(image)){ ;
__p += '\n	 <div id="cta_img" style="background-image:url(\'' +
((__t = ( decode_utf8(image) )) == null ? '' : __t) +
'\')" tabindex="0">.\n    <img alt="' +
((__t = ( decode_utf8(altTextProduct(title)) )) == null ? '' : __t) +
'" src=\'' +
((__t = ( decode_utf8(image) )) == null ? '' : __t) +
'\' style="position: fixed; left: -100000px;" aria-hidden="true"/>\n  </div>\n	 ';
 } ;
__p += '\n	 <div id="cta_product_name">' +
((__t = ( decode_utf8(title) )) == null ? '' : __t) +
'</div>\n	 <div id="cta_text">' +
((__t = ( decode_utf8(link_text) )) == null ? '' : __t) +
'</div>\n	</div>\n</a>\n';

}
return __p
}